module.exports = __webpack_public_path__ + "77d1adb12ad34e56531d698dfed3852d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/popular.svg
// module id = 1933
// module chunks = 0